import React from "react";
import {ClientData} from "./client-data";

const ClientDataContext = React.createContext({
  client: {} as ClientData,
  changeClient: (id: number) => {}
});

export default ClientDataContext;